export default "__VITE_ASSET__0dd48286__"